module.exports = __webpack_public_path__ + "static/media/lora.c8e50f46.jpg";